const template = document.getElementById('pathwaySettings')?.content || null;

const templateConfig = template ? {
    // Gift Voucher Thumbnail
    gift_voucher_thumbnail: {
        image: template.querySelector('[gift-voucher-thumbnail]'),
        background: template.querySelector('[gift-voucher-thumbnail-background]'),
    },
    // Donation Campaign Pages
    donation_campaign: template.querySelector('[donation-campaigns-json]') ? JSON.parse(template
        .querySelector('[donation-campaigns-json]')
        ?.getAttribute('donation-campaigns-json')) : [],
    // Booking Pathway Settings
    ticket_type_names: JSON.parse(template
        .querySelector('[ticket-type-names]')
        ?.getAttribute('ticket-type-names')),
    accessibility_key_message: template.querySelector('[accessibility-key-message]'),
    booking_advisory_message: template.querySelector('[booking-advisory-message]'),
    seating_plan_video: template.querySelector('[seating-plan-video]'),
    general_admission_message: template.querySelector('[general-admission-message]'),
    ticket_protection_message: template.querySelector('[ticket-protection-message]'),
    basket_summary_message: template.querySelector('[basket-summary-message]'),
    guest_user_upsell: {
        spektrix_membership: template.querySelector('[guest-user-upsell-spektrix-membership]'),
        with_discount: {
            title: template.querySelector('[guest-user-upsell-with-discount-title]'),
            price: template.querySelector('[guest-user-upsell-with-discount-price]'),
            message: template.querySelector('[guest-user-upsell-with-discount-message]'),
        },
        no_discount: {
            title: template.querySelector('[guest-user-upsell-no-discount-title]'),
            price: template.querySelector('[guest-user-upsell-no-discount-price]'),
            message: template.querySelector('[guest-user-upsell-no-discount-message]'),
        }
    },
    member_message: {
        with_discount: {
            title: template.querySelector('[member-message-with-discount-title]'),
            message: template.querySelector('[member-message-with-discount-message]'),
        },
        no_discount: {
            title: template.querySelector('[member-message-no-discount-title]'),
            message: template.querySelector('[member-message-no-discount-message]'),
        },
    },
    // Event Page Settings
    coming_soon_priority_discount_message: template.querySelector('[coming-soon-priority-discount-message]'),
    coming_soon_general_discount_message: template.querySelector('[coming-soon-general-discount-message]'),
    priority_open_priority_discount_message: template.querySelector('[priority-open-priority-discount-message]'),
    priority_open_general_discount_message: template.querySelector('[priority-open-general-discount-message]'),
    schools_performance_message: {
        message: template.querySelector('[schools-performance-message-message]'),
        button: template.querySelector('[schools-performance-message-button]')
    },
    pwyc_button: template.querySelector('[pwyc-button]'),
    filters_no_results_message: template.querySelector('[filters-no-results-message]'),
    join_and_book_memberships: {
        introduction: template.querySelector('[join-and-book-memberships-introduction]'),
        playhouse_pass: {
            membership: template.querySelector('[join-and-book-memberships-playhouse-pass-membership]'),
            title: template.querySelector('[join-and-book-memberships-playhouse-pass-title]'),
            price: template.querySelector('[join-and-book-memberships-playhouse-pass-price]'),
            benefits: template.querySelector('[join-and-book-memberships-playhouse-pass-benefits]'),
        },
        playhouse_pass_premium: {
            membership: template.querySelector('[join-and-book-memberships-playhouse-pass-premium-membership]'),
            title: template.querySelector('[join-and-book-memberships-playhouse-pass-premium-title]'),
            price: template.querySelector('[join-and-book-memberships-playhouse-pass-premium-price]'),
            benefits: template.querySelector('[join-and-book-memberships-playhouse-pass-premium-benefits]'),
        },
        membership_removal_error_message: {
            title: template.querySelector('[join-and-book-memberships-membership-removal-error-message-title]'),
            message: template.querySelector('[join-and-book-memberships-membership-removal-error-message-message]'),
        }
    },
    event_tags_and_memberships: template.querySelector('[event-tags-and-memberships]') ? JSON.parse(template
        .querySelector('[event-tags-and-memberships]')
        ?.getAttribute('event-tags-and-memberships')) : {},
} : {};

export default templateConfig;